import { User } from './auth.types'
import useAuth from './useAuth'

export enum ActionTypes {
  DELETABLE = 'deletable',
  UPDATABLE = 'updatable',
  CREATABLE = 'creatable',
  READABLE = 'readable',
}

export const DefaultUserRoleEnums = {
  // 1 admin , 2 桃園機場 3. 地勤公司 4. 航務處
  /**
   * Admin
   */
  ADMIN: 1,
  /**
   * 桃園機場
   */
  TAOYUAN_AIRPORT: 2,
  /**
   * 地勤公司
   */
  GROUND_HANDLING_COMPANY: 3,
  /**
   * 航務處
   */
  OPERATIONS_DEPARTMENT: 4,
}

export const useGetUserRoleEnum = () => {
  const { user } = useAuth()
  return user?.roleObj?.id as number
}

export const getUserRoleEnum = (roleId?: number): User['role'] => {
  switch (roleId) {
    case DefaultUserRoleEnums.ADMIN:
      return 'admin'
    case DefaultUserRoleEnums.TAOYUAN_AIRPORT:
      return 'TYAP'
    case DefaultUserRoleEnums.GROUND_HANDLING_COMPANY:
      return 'APCompany'
    case DefaultUserRoleEnums.OPERATIONS_DEPARTMENT:
      return 'AMD'
    default:
      return 'Others'
  }
}
